import { PagedData } from "@/services/models/shared/PagedData";
import { AxiosResponse } from "axios";
import {
  NetworkIDTFilterOptions,
  NetworkIDTListItem,
  NewNetworkIDT,
  UpdateNetworkIDT,
} from "@/services/models/NetworkIDT";
import BimsHttpService from "@/services/BimsHttpService";
import FileProvider from "@/utilities/providers/FileProvider";

class NetworkIDTService {
  /**
   * @description Returns a paged list of network IDTs.
   */
  getNetworkIDTs(
    filter: NetworkIDTFilterOptions
  ): Promise<PagedData<NetworkIDTListItem>> {
    return BimsHttpService.get(`/networkIDTs`, {
      params: filter,
    }).then((response: AxiosResponse<PagedData<NetworkIDTListItem>>) => {
      return response.data as PagedData<NetworkIDTListItem>;
    });
  }

  /**
   * @description Returns the current network IDT number
   */
  getCurrentNetworkIDTNumber(): Promise<number | null> {
    return BimsHttpService.get("/networkIDTs/Number").then((response: AxiosResponse<number | null>) => {
      return response.data as number | null;
    });
  }

  /**
   * @description Adds a new network IDT
   */
  addNetworkIDT(networkIDT: NewNetworkIDT): Promise<any> {
    return BimsHttpService.post(`/networkIDTs`, networkIDT);
  }

  /**
 * @description Updates the network IDT
 */
  updateNetworkIDT(networkIDT: UpdateNetworkIDT): Promise<any> {
    return BimsHttpService.put(`/networkIDTs`, networkIDT);
  }

  /**
   * @description Creates a new Network IDT Number.
   */
  createNetworkIDTNumber(idtNumber: string): Promise<boolean> {
    return BimsHttpService.post(`/networkIDTs/number`, {
      IDTNumber: idtNumber,
    });
  }
  /**
   * @description Fetches the total amount charged from the backend.
   */
  getTotalAmountCharged(): Promise<number> {
    return BimsHttpService.get(`/networkIDTs/total`)
      .then((response: AxiosResponse<number>) => {
        return response.data;
      });
  }

  /**
   * @description Deletes a Network IDT with the specified SL, SA, and Famis Department
   */
  deleteNetworkIDT(sl: string, sa: string, famisDepartment: string): Promise<any> {
    return BimsHttpService.delete(`/networkIDTs/${famisDepartment}/${sl}-${sa}`);
  }

  /**
   * @description Downloads the CSV export for the base account listing
   */
  public downloadNetworkIDTFrozenAndMissingAccounts(): Promise<any> {
    return BimsHttpService.get(`/networkIDTs/accounts/frozenAndMissing/report`).then(response => {
      return FileProvider.ForceFileDownload(response)
    })
  }
}

export default new NetworkIDTService();
